<template>
  <span>
    <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
  </span>
</template>

<script>
  import columnChartMixin from "./columnChartMixin";

  export default {
    name: "ChartQrtPorCompetencia",
    mixins: [columnChartMixin],
    props: {
      dadosPorCompetencia: {
        type: Object,
        required: true,
      },
      categories: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      chartOptions: {},
    }),
    methods: {
      setChartOptions() {
        this.chartOptions = this.getColumnChartOptions(
          this.getQrtPorCompetenciaRemainingChartOptions()
        );
      },
      getQrtPorCompetenciaRemainingChartOptions() {
        return {
          xAxis: {
            type: "category",
            // categories: this.categories,
            title: {
              text: "Competência",
            },
          },
          series: [
            {
              name: "QRT",
              data: this.categories
                .map((category) => {
                  return category in this.dadosPorCompetencia
                    ? {
                        name: category,
                        y: Number(this.dadosPorCompetencia[category].qrt),
                      }
                    : {
                        name: category,
                        y: 0,
                      };
                })
                .filter((val) => val !== null && val.y !== null && val.y > 0),
            },
          ],
        };
      },
    },
    watch: {
      dadosPorCompetencia() {
        this.setChartOptions();
      },
    },
  };
</script>

<style></style>
